import React, { useEffect } from 'react'

import { useAudio } from '@/hooks/useAudio'

interface AudioPlayerProps {
  autoPreload?: boolean
  className?: string
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({
  autoPreload = true,
  className = ''
}) => {
  const { preloadAllSounds } = useAudio()

  useEffect(() => {
    if (autoPreload) {
      preloadAllSounds()
    }
  }, [autoPreload, preloadAllSounds])

  // 这个组件主要用于预加载音频，不渲染任何可见内容
  return <div className={`audio-player ${className}`.trim()} style={{ display: 'none' }} />
}

// 全局音频播放器组件，建议在App.tsx中使用
export const GlobalAudioPlayer: React.FC = () => {
  return <AudioPlayer autoPreload={true} />
}

// 音频控制面板组件（可选，用于调试或设置）
interface AudioControlPanelProps {
  showControls?: boolean
  onVolumeChange?: (volume: number) => void
}

export const AudioControlPanel: React.FC<AudioControlPanelProps> = ({
  showControls = false,
  onVolumeChange
}) => {
  const { playSuccess, playError } = useAudio()
  const [volume, setVolume] = React.useState(0.7)

  const handleVolumeChange = (newVolume: number) => {
    setVolume(newVolume)
    onVolumeChange?.(newVolume)
  }

  const testSuccess = () => playSuccess({ volume })
  const testError = () => playError({ volume })

  if (!showControls) return null

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-4">
      <h3 className="text-lg font-medium text-gray-900">音效控制</h3>
      
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            音量: {Math.round(volume * 100)}%
          </label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={(e) => handleVolumeChange(parseFloat(e.target.value))}
            className="w-full"
          />
        </div>
        
        <div className="flex space-x-2">
          <button
            onClick={testSuccess}
            className="px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            🎵 测试成功音效
          </button>
          <button
            onClick={testError}
            className="px-3 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            🎵 测试失败音效
          </button>
        </div>
      </div>
    </div>
  )
}

export default AudioPlayer